import React, { FunctionComponent, ReactNode } from 'react';
import IdeeIcon from 'assets/icons/idee';

export type HighlightProps = {
  children: ReactNode;
  className?: string;
};

const BASE_CLASSES = 'bg-white rounded p-4 text-sm relative flex items-center text-navy-600 [&_p]:p-0 [&_p]:m-0';

const Highlight: FunctionComponent<HighlightProps> = (props: HighlightProps) => {
  const { children, className } = props;

  return (
    <div className={className ? `${BASE_CLASSES} ${className}` : BASE_CLASSES}>
      <div className="w-[60px] h-[60px] mr-4 flex-shrink-0">
        <IdeeIcon className="fill-navy-600 w-full h-full" />
      </div>

      {children}
    </div>
  );
};

export default Highlight;
